/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { light, text, dark } = colors;
const { borderRadius } = borders;
const { size } = typography;

const menuItem = {
  styleOverrides: {
    root: {
      minWidth: pxToRem(160),
      minHeight: "unset",
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: text.main,
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus": {
        backgroundColor: light.main,
        color: dark.main,
      },

      // Enhanced multiselect styling - distinct selected state
      "&.Mui-selected": {
        backgroundColor: `rgba(26, 115, 232, 0.08) !important`, // Light blue background
        borderLeft: `${pxToRem(3)} solid #1A73E8`, // Blue left border
        color: "#1A73E8 !important", // Blue text
        fontWeight: 600,

        "&:hover, &:focus": {
          backgroundColor: `rgba(26, 115, 232, 0.16) !important`, // Darker blue on hover
          color: "#1565C0 !important",
        },

        // Style checkboxes within selected items
        "& .MuiCheckbox-root": {
          color: "#1A73E8",
        },

        // Style text within selected items
        "& .MuiTypography-root": {
          fontWeight: 600,
          color: "#1A73E8",
        },
      },

      // Checkbox alignment in menu items
      "& .MuiCheckbox-root": {
        padding: pxToRem(4),
        marginRight: pxToRem(8),
        
        "&.Mui-checked": {
          color: "#1A73E8",
        },
      },

      // Typography styling within menu items for better overflow handling
      "& .MuiTypography-root": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        flex: 1,
        minWidth: 0,
      },

      // Enhanced hover state for multiselect items
      "&:hover:not(.Mui-selected)": {
        backgroundColor: "#f5f5f5",
        transition: "background-color 0.15s ease",
      },
    },
  },
};

export default menuItem;
